/*
 * PureSpec PDP behaviour: tab switching, thumbnail swap, lightbox/zoom (with
 * focus trap), quantity stepper, and variant selection.
 * Per-product data (zoom images, variants, locale-formatted prices) is provided
 * by the inline <script type="application/json" id="ps-pdp-data"> block so this
 * file stays static, cacheable, and loadable with `defer`.
 */
(function () {
  var dataEl = document.getElementById('ps-pdp-data');
  var psData = { zoomImages: [], variants: [], variantPrices: {} };
  if (dataEl) {
    try { psData = JSON.parse(dataEl.textContent); } catch (e) { /* leave defaults */ }
  }
  var psZoomImages = psData.zoomImages || [];
  var psVariants = psData.variants || [];
  var psVariantPrices = psData.variantPrices || {};

  var tablist = document.getElementById('ps-product-tabs');
  if (tablist) {
    tablist.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab]');
      if (!btn) return;
      var tabId = btn.dataset.tab;

      tablist.querySelectorAll('.ps-tab').forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');

      document.querySelectorAll('.ps-tab-panel').forEach(function (p) { p.hidden = true; });
      document.getElementById('ps-tab-' + tabId).hidden = false;
    });
  }

  var thumbGrid = document.getElementById('ps-thumbnail-grid');
  if (thumbGrid) {
    thumbGrid.addEventListener('click', function (e) {
      var thumb = e.target.closest('.ps-thumbnail');
      if (!thumb) return;
      var img = document.getElementById('ps-pdp-image');
      if (img) {
        img.src = thumb.dataset.imageUrl;
        if (thumb.dataset.zoomUrl) img.dataset.zoomUrl = thumb.dataset.zoomUrl;
      }
      thumbGrid.querySelectorAll('.ps-thumbnail').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  }

  /* ----- Lightbox / image zoom ----- */
  var psLightbox = document.getElementById('ps-lightbox');
  var psLightboxImg = document.getElementById('ps-lightbox-image');
  var psLightboxStage = document.getElementById('ps-lightbox-stage');
  var psLightboxCounter = document.getElementById('ps-lightbox-counter');
  var psMainImage = document.getElementById('ps-main-image');
  var psPdpImage = document.getElementById('ps-pdp-image');
  var psLightboxIndex = 0;
  var psLightboxZoomed = false;
  var psLightboxLastFocus = null;

  function psOpenLightbox(index) {
    if (!psLightbox) return;
    if (psZoomImages.length === 0) {
      if (psPdpImage && psPdpImage.dataset.zoomUrl) {
        psLightboxImg.src = psPdpImage.dataset.zoomUrl;
        psLightboxImg.alt = psPdpImage.alt || '';
      } else if (psPdpImage) {
        psLightboxImg.src = psPdpImage.src;
        psLightboxImg.alt = psPdpImage.alt || '';
      }
    } else {
      psLightboxIndex = ((index % psZoomImages.length) + psZoomImages.length) % psZoomImages.length;
      psLightboxImg.src = psZoomImages[psLightboxIndex].src;
      psLightboxImg.alt = psZoomImages[psLightboxIndex].alt || '';
      if (psLightboxCounter) {
        psLightboxCounter.textContent = (psLightboxIndex + 1) + ' / ' + psZoomImages.length;
      }
    }
    psLightboxZoomed = false;
    psLightboxImg.classList.remove('is-zoomed');
    psLightboxImg.style.transformOrigin = '';
    psLightboxLastFocus = document.activeElement;
    psLightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    var firstControl = psLightbox.querySelector('.ps-lightbox__close');
    if (firstControl) firstControl.focus();
  }

  function psCloseLightbox() {
    if (!psLightbox) return;
    if (psZoomImages.length > 0 && psPdpImage) {
      var current = psZoomImages[psLightboxIndex];
      if (current) {
        psPdpImage.src = current.src.replace('width=2400', 'width=1000');
        psPdpImage.alt = current.alt || '';
        psPdpImage.dataset.zoomUrl = current.src;
      }
      if (thumbGrid) {
        thumbGrid.querySelectorAll('.ps-thumbnail').forEach(function (t, i) {
          t.classList.toggle('active', i === psLightboxIndex);
        });
      }
    }
    psLightbox.hidden = true;
    document.body.style.overflow = '';
    psLightboxZoomed = false;
    psLightboxImg.classList.remove('is-zoomed');
    psLightboxImg.style.transformOrigin = '';
    if (psLightboxLastFocus && typeof psLightboxLastFocus.focus === 'function') {
      psLightboxLastFocus.focus();
    }
    psLightboxLastFocus = null;
  }

  function psLightboxStep(delta) {
    psOpenLightbox(psLightboxIndex + delta);
  }

  if (psMainImage) {
    psMainImage.addEventListener('click', function () {
      var src = psPdpImage && psPdpImage.src;
      var matched = -1;
      if (src) {
        var srcBase = src.split('?')[0];
        for (var i = 0; i < psZoomImages.length; i++) {
          var z = psZoomImages[i].src.split('?')[0];
          if (z === srcBase || srcBase.indexOf(z.replace(/_\d+x\.?/, '')) !== -1) { matched = i; break; }
        }
        if (matched === -1) {
          for (var k = 0; k < psZoomImages.length; k++) {
            var slugA = srcBase.replace(/_\d+x/, '').split('/').pop();
            var slugB = psZoomImages[k].src.split('?')[0].replace(/_\d+x/, '').split('/').pop();
            if (slugA === slugB) { matched = k; break; }
          }
        }
      }
      psOpenLightbox(matched > -1 ? matched : 0);
    });
  }

  var psLightboxClose = document.getElementById('ps-lightbox-close');
  if (psLightboxClose) psLightboxClose.addEventListener('click', psCloseLightbox);
  var psLightboxPrev = document.getElementById('ps-lightbox-prev');
  if (psLightboxPrev) psLightboxPrev.addEventListener('click', function (e) { e.stopPropagation(); psLightboxStep(-1); });
  var psLightboxNext = document.getElementById('ps-lightbox-next');
  if (psLightboxNext) psLightboxNext.addEventListener('click', function (e) { e.stopPropagation(); psLightboxStep(1); });

  if (psLightbox) {
    psLightbox.addEventListener('click', function (e) {
      if (e.target === psLightbox || e.target === psLightboxStage) psCloseLightbox();
    });
  }

  if (psLightboxImg && psLightboxStage) {
    psLightboxImg.addEventListener('click', function (e) {
      e.stopPropagation();
      psLightboxZoomed = !psLightboxZoomed;
      psLightboxImg.classList.toggle('is-zoomed', psLightboxZoomed);
      if (!psLightboxZoomed) psLightboxImg.style.transformOrigin = '';
    });
    psLightboxStage.addEventListener('mousemove', function (e) {
      if (!psLightboxZoomed) return;
      var rect = psLightboxStage.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      psLightboxImg.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!psLightbox || psLightbox.hidden) return;
    if (e.key === 'Escape') psCloseLightbox();
    else if (e.key === 'ArrowLeft') psLightboxStep(-1);
    else if (e.key === 'ArrowRight') psLightboxStep(1);
    else if (e.key === 'Tab') {
      /* Trap focus inside the dialog while it is open. */
      var focusable = psLightbox.querySelectorAll('button:not([hidden]), [href], input, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!psLightbox.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  var qtyContainer = document.querySelector('.ps-qty');
  if (qtyContainer) {
    qtyContainer.addEventListener('click', function (e) {
      var input = qtyContainer.querySelector('input');
      if (e.target.closest('.ps-qty-decrease')) { input.stepDown(); input.dispatchEvent(new Event('change')); }
      if (e.target.closest('.ps-qty-increase')) { input.stepUp(); input.dispatchEvent(new Event('change')); }
    });
  }

  /* ----- Variant selection (no-op when there are no variant pickers) ----- */
  function psPriceFor(v) {
    return (psVariantPrices[v.id] && psVariantPrices[v.id].price) || ('$' + (v.price / 100).toFixed(2));
  }
  function psComparePriceFor(v) {
    return (psVariantPrices[v.id] && psVariantPrices[v.id].compare) || ('$' + (v.compare_at_price / 100).toFixed(2));
  }

  document.querySelectorAll('.ps-variant-picker').forEach(function (picker) {
    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('.ps-variant-pill');
      if (!pill) return;
      picker.querySelectorAll('.ps-variant-pill').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('active');
      pill.setAttribute('aria-pressed', 'true');
      updatePSVariant();
    });
  });

  function updatePSVariant() {
    var options = [];
    document.querySelectorAll('.ps-variant-picker').forEach(function (picker) {
      var active = picker.querySelector('.ps-variant-pill.active');
      if (active) options.push(active.dataset.optionValue);
    });

    for (var i = 0; i < psVariants.length; i++) {
      var v = psVariants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (v['option' + (j + 1)] !== options[j]) { match = false; break; }
      }
      if (match) {
        document.getElementById('ps-variant-id').value = v.id;
        document.getElementById('ps-pdp-price').textContent = psPriceFor(v);
        var compare = document.getElementById('ps-pdp-compare');
        if (compare) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compare.textContent = psComparePriceFor(v);
            compare.style.display = '';
          } else {
            compare.style.display = 'none';
          }
        }
        var cartBtn = document.querySelector('#ps-product-form [type="submit"]');
        var stockDot = document.querySelector('.ps-stock-dot');
        var stockText = stockDot ? stockDot.nextElementSibling : null;
        if (v.available) {
          if (cartBtn) {
            cartBtn.disabled = false;
            cartBtn.innerHTML = cartBtn.innerHTML.replace('Sold Out', 'Add to Cart');
          }
          if (stockDot) { stockDot.classList.remove('ps-stock-dot--out-of-stock'); stockDot.classList.add('ps-stock-dot--in-stock'); }
          if (stockText) { stockText.textContent = 'In Stock'; stockText.classList.remove('ps-text-destructive'); stockText.classList.add('ps-text-emerald'); }
        } else {
          if (cartBtn) {
            cartBtn.disabled = true;
            cartBtn.innerHTML = cartBtn.innerHTML.replace('Add to Cart', 'Sold Out');
          }
          if (stockDot) { stockDot.classList.remove('ps-stock-dot--in-stock'); stockDot.classList.add('ps-stock-dot--out-of-stock'); }
          if (stockText) { stockText.textContent = 'Out of Stock'; stockText.classList.remove('ps-text-emerald'); stockText.classList.add('ps-text-destructive'); }
        }
        if (v.featured_image) {
          var img = document.getElementById('ps-pdp-image');
          if (img) {
            var fBase = v.featured_image.src.split('?')[0];
            var fQuery = (v.featured_image.src.split('?')[1] || '').replace(/[&]?width=\d+/, '');
            img.src = fBase + '?width=1000' + (fQuery ? '&' + fQuery : '');
            img.dataset.zoomUrl = fBase + '?width=2400' + (fQuery ? '&' + fQuery : '');
          }
        }
        break;
      }
    }
  }
})();
